// Canonical money format for the app (Dominican Republic, DOP):
// prefix "DOP$", thousands separator ",", exactly 2 decimals
// e.g. 200 -> "DOP$200.00", 1500.5 -> "DOP$1,500.50".
// NOTE: Intl.NumberFormat('es-DO', { style: 'currency', currency: 'DOP' })
// renders "RD$1,500.50", which must NOT be used: printed tickets already
// say "DOP$" and that label must stay stable for customers.
export const formatCurrency = (amount: number): string => {
  const number = new Intl.NumberFormat('es-DO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
  return `DOP$${number}`;
};

export const formatDate = (date: Date): string => {
  return new Intl.DateTimeFormat('es-CO', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date(date));
};

export const formatDateTime = (date: string | Date | null): string => {
  if (!date) return 'Fecha no disponible';

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;

    if (isNaN(dateObj.getTime())) {
      return 'Fecha inválida';
    }

    return dateObj.toLocaleString('es-ES', {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    console.error('Error al formatear fecha:', error);
    return 'Error en fecha';
  }
};